/**
 * Asynchronously loads the component for ReleasePage
 */

import { lazyLoad } from 'utils/loadable';

export const UserStories = lazyLoad(
  () => import('./index'),
  module => {
    return module.UserStories;
  },
);
